"use client";

// ──────────────────────────────────────────────────────────────────────────
//  AnalyticsProvider — boots PostHog on first mount, wires sign-in →
//  identify, sign-out → reset. Mounted once at the root layout level.
//  Renders nothing.
// ──────────────────────────────────────────────────────────────────────────

import { useEffect } from "react";
import { useAuth } from "@/lib/auth";
import { initAnalytics, identifyUser, resetIdentity } from "@/lib/analytics";

export function AnalyticsProvider() {
  const auth = useAuth();

  // Boot the tracker once on mount.
  useEffect(() => {
    initAnalytics();
  }, []);

  // Tie events to the signed-in user (hashed bnet_id) once auth resolves;
  // forget the identity on sign-out.
  useEffect(() => {
    if (auth.state === "signed-in") {
      void identifyUser(auth.user.bnet_id, { region: auth.user.region });
    } else if (auth.state === "anonymous") {
      resetIdentity();
    }
  }, [auth.state, auth.state === "signed-in" ? auth.user.bnet_id : null]);

  return null;
}
